import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { terminologyPreview } from '../terminologyView.js';
import TerminologyCard from '../TerminologyCard.jsx';
import { track } from '../../analytics/analytics.js';

export default function TerminologyPreview({ state }) {
    const navigate = useNavigate();
    const [selected, setSelected] = useState('metaphor');
    const groups = terminologyPreview(state.terminology);
    const group = groups.find(g => g.id === selected) || groups[0];
    if (!group) return null; // Never advertise a sample that has not loaded.
    const open = () => {
        track('terminology_open');
        navigate(state.user ? '/terminology' : '/login?mode=signup', { state: { from: '/terminology' } });
    };
    return <section id="terminology-preview" className="py-12 md:py-16 border-t border-book-line scroll-mt-24">
        <div className="max-w-6xl mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-8 items-start">
            <div>
                <p className="font-display text-book-accent text-xs font-semibold mb-3">A small revision habit, ready whenever you need it</p>
                <h2 className="font-display text-book-text text-2xl md:text-3xl font-bold leading-tight">Literary terms you can actually use in an answer</h2>
                <p className="font-serif text-book-muted leading-relaxed mt-4">Go from a definition to a text example and an exam tip. Try a term here, then explore the full searchable glossary with a free account.</p>
                <button onClick={open} className="mt-6 px-5 py-3 rounded-full border border-book-accent text-book-accent font-display text-sm font-semibold hover:bg-book-accent/10">{state.user ? 'Explore literary terms' : 'Create a free account to explore all terms'}</button>
                <p className="mt-2 font-serif text-book-muted text-xs">No pack purchase needed for the glossary.</p>
            </div>
            <div className="min-w-0">
                <div className="flex flex-wrap gap-2 mb-3" aria-label="Choose a sample term">{groups.map(g => <button key={g.id} aria-pressed={g.id === group.id} onClick={() => { setSelected(g.id); track('terminology_preview'); }} className={'rounded-full border px-4 py-2 font-display text-sm ' + (g.id === group.id ? 'bg-book-accent text-book-pageDark border-book-accent' : 'border-book-line text-book-text hover:border-book-accent')}>{g.name}</button>)}</div>
                <TerminologyCard group={group} packs={state.packs} preview />
            </div>
        </div>
    </section>;
}
